import React from 'react';
import { Session } from './model/Session';

interface IForumAuthContext {
	session: Session;
	logout: () => any;
}

export const forum_auth_context = React.createContext({} as IForumAuthContext);
